// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { GradientMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { InputParameterBoolean } from '../InputParamaterClasses/InputParameterBoolean';
export class SUPERTREND extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'SUPER TREND';
        this.Comments = 'SUPERTREND';
        this.SetIndicatorLine('Supertrend line', Color.Blue, 1, LineStyle.SimpleChart);
        this.SeparateWindow = false;
        this.AtrPeriod = 10;
        super.InputParameter(new InputParameterInteger('AtrPeriod', 'Period of ATR', 0, 1, 100));
        this.Digit = 3;
        super.InputParameter(new InputParameterInteger('Digit', 'Digit', 1, 1, 100));
        this.IsCheckedCloud = false;
        super.InputParameter(new InputParameterBoolean('IsCheckedCloud', 'Display clouds', 2));
        this.DownTrendColor = Color.OrangeRed;
        this.UpTrendColor = Color.CadetBlue;
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    createInternalIndicators() {
        this._ATR = this.Indicators.iATR(this.CurrentData, this.AtrPeriod);
        return [this._ATR];
    }
    GetIndicatorShortName() {
        return 'SUPERTREND(' + this.AtrPeriod + ')';
    }
    getCustomName() {
        return 'SUPERTREND (' + this.ProjectName + ')';
    }
    NextBar() {
        super.NextBar();
        this._prevUP = this._down;
        this._prevDown = this._up;
        this._prevTrend = this._currTrend;
    }
    OnQuote() {
        super.OnQuote();
        const middle = (this.CurrentData.getPriceByType(PriceType.High) + this.CurrentData.getPriceByType(PriceType.Low)) / 2;
        this._down = middle + this.Digit * this._ATR.GetValue();
        this._up = middle - this.Digit * this._ATR.GetValue();
        if (this.CurrentData.getPriceByType(PriceType.Close) > this._prevUP) {
            this._currTrend = 1;
        }
        else if (this.CurrentData.getPriceByType(PriceType.Close) < this._prevDown) {
            this._currTrend = -1;
        }
        else {
            this._currTrend = this._prevTrend;
        }
        if (this._currTrend > 0 && this._up < this._prevDown && this._currTrend <= this._prevTrend) {
            this._up = this._prevDown;
        }
        if (this._currTrend < 0 && this._down > this._prevUP && this._currTrend >= this._prevTrend) {
            this._down = this._prevUP;
        }
        if (this._currTrend === 1) {
            this.SetValue(0, this._up);
        }
        else {
            this.SetValue(0, this._down);
        }
        if (this.IsCheckedCloud) {
            this.SetCloud(0, 0, this.GetValue(0, 0), this.CurrentData.getPriceByType(PriceType.Open), Color.FromHexToArgb(60, this.DownTrendColor), Color.FromHexToArgb(60, this.UpTrendColor), GradientMode.Simple);
        }
    }
}
